import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  key: 0,
  class: "role-box"
};
var _hoisted_3 = {
  class: "top-panel",
  style: {
    "display": "none"
  }
};
var _hoisted_4 = {
  class: "header-tab"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  key: 1,
  class: "content-box"
};
var _hoisted_7 = {
  key: 2,
  class: "empty-box"
};
import { ref, provide, computed, watch } from 'vue';
import classTeacher from './pages/classTeacher.vue';
import schoolPage from './pages/schoolPage.vue';
import teacher from './pages/teacher.vue';
export default {
  __name: 'InteractiveData',
  props: {
    auth: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var emptyImage = require('@/assets/home/dataReport/images/empty-icon.png');
    var props = __props;
    var active = ref('teacher');
    provide('activeName', active);
    var handleClick = function handleClick(val) {
      active.value = val;
    };
    var typeOptions = [{
      label: '教师',
      value: 'teacher'
    }, {
      label: '年级主任',
      value: 'director'
    }, {
      label: '学校',
      value: 'rector'
    }];
    var permisOptions = computed(function () {
      var _props$auth;
      console.log('1111', props.auth);
      if ((_props$auth = props.auth) !== null && _props$auth !== void 0 && _props$auth.length) {
        var permis = typeOptions.filter(function (item) {
          var findIndex = props.auth.findIndex(function (itm) {
            return itm.permission === item.value;
          });
          return findIndex > -1;
        });
        if (permis.length > 0) {
          handleClick(permis[0].value);
        }
        return permis || [];
      }
      return [];
    });
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [permisOptions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_t_select, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return active.value = $event;
        }),
        options: permisOptions.value
      }, null, 8, ["modelValue", "options"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "header-title"
      }, "课堂互动数据看板", -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permisOptions.value, function (item, index) {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass([{
            active: active.value === item.value
          }, 'btn-class']),
          onClick: function onClick($event) {
            return handleClick(item.value);
          }
        }, _toDisplayString(item.label), 11, _hoisted_5);
      }), 128))])]), permisOptions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [active.value === 'rector' ? (_openBlock(), _createBlock(schoolPage, {
        key: 0
      })) : active.value === 'director' ? (_openBlock(), _createBlock(classTeacher, {
        key: 1
      })) : (_openBlock(), _createBlock(teacher, {
        key: 2
      }))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_Empty, {
        icon: _unref(emptyImage),
        fullHeight: true
      }, {
        description: _withCtx(function () {
          return _toConsumableArray(_cache[2] || (_cache[2] = [_createElementVNode("div", {
            class: "empty-des"
          }, [_createElementVNode("p", null, "当前尚无任何数据权限"), _createElementVNode("p", null, "请找管理员进行应用授权范围设定")], -1)]));
        }),
        _: 1
      }, 8, ["icon"])]))]);
    };
  }
};